import { render, staticRenderFns } from "./TopButtons.vue?vue&type=template&id=0a4d61ba&scoped=true"
import script from "./TopButtons.vue?vue&type=script&lang=js"
export * from "./TopButtons.vue?vue&type=script&lang=js"
import style0 from "./TopButtons.vue?vue&type=style&index=0&id=0a4d61ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d61ba",
  null
  
)

export default component.exports